
import React from 'react';
import {
    Grid,
    Typography,
} from "@mui/material";
import "./styles.css";

const JobUpdate = () => {
    return (
        <Grid className="category" style={{ backgroundColor: '#E5F5E9' }}>
            <Grid display='flex' flexDirection='column' style={{ margin: '2%', paddingTop: '10px' }}>
                <Typography style={{ color: '#1E561F', fontWeight: '600' }}>Job Update</Typography>
                <Typography style={{ fontSize: '15px' }}>The requested Job has been completed successfully by Plumber name. The complete payment has been done already and there is no balance payment from Home Owner</Typography>
            </Grid>
        </Grid>
    );

};

export default JobUpdate;